// src/utils/smsKode.js
import { useEffect, useRef } from "react";

// Android (Chrome): les koden fra SMS-en med WebOTP når kunden godtar det. SMS-er med
// kode slutter med «@status.roykensykkelservice.no #kode» (customerPortal.js, bookings.js).
// Koden fylles inn og fokus flyttes til knappen; skjemaet sendes ikke av seg selv.
// iPhone foreslår koden over tastaturet via autoComplete="one-time-code".
export function useSmsKode(aktiv, onKode) {
  const onKodeRef = useRef(onKode);
  onKodeRef.current = onKode;
  useEffect(() => {
    if (!aktiv || typeof window === 'undefined' || !('OTPCredential' in window)) return undefined;
    const avbryt = new AbortController();
    navigator.credentials
      .get({ otp: { transport: ['sms'] }, signal: avbryt.signal })
      .then((otp) => { if (otp?.code && /^\d{6}$/.test(otp.code)) onKodeRef.current(otp.code); })
      .catch(() => {});
    return () => avbryt.abort();
  }, [aktiv]);
}
